// removed by extract-text-webpack-plugin
module.exports = {"container":"Tickets__container__1IM2q","row":"Tickets__row__2V3CP","colLeft":"Tickets__colLeft__1UzDW","colRight":"Tickets__colRight__3qtIm","quickPickButton":"Tickets__quickPickButton__2Ct6p","loadDataBtn":"Tickets__loadDataBtn__1pyEX","noLeftMargin":"Tickets__noLeftMargin__2ecAn","separator":"Tickets__separator__GmkO-","tableContainer":"Tickets__tableContainer__2TVI9"};


//////////////////
// WEBPACK FOOTER
// ./src/Containers/AdminScreens/Tickets/Tickets.css
// module id = 594
// module chunks = 0